export default "__VITE_ASSET__2eef0181__"